window.layout = {
  header_height : 35,
  footer_height: 120,
};
